/**
 * Opus 上行 MQTT：多段 `u16le(帧长) + 裸 Opus` 拼成一条 MQTT payload，设备按段循环解析（与下行一致）。
 * 减轻设备侧「每条 MQTT 单独处理」的次数与缓冲压力。
 *
 * - 默认每 **5 帧** 发一条（WebCodecs 20ms/帧 → 约 **100ms** 一条 MQTT）。
 * - 环境变量：`REACT_APP_UPLINK_OPUS_BATCH_FRAMES`（整数 **1～32**）覆盖批大小。
 */

export function getOpusUplinkBatchFrameCount(): number {
  const raw = process.env.REACT_APP_UPLINK_OPUS_BATCH_FRAMES?.trim();
  const n = parseInt(raw || '', 10);
  if (Number.isFinite(n) && n >= 1 && n <= 32) {
    return Math.floor(n);
  }
  return 5;
}

/** 将多帧裸 Opus 拼成设备约定的 MQTT 二进制体（无额外外层前缀） */
export function concatOpusSubframesWithU16leLengthPrefix(frames: ReadonlyArray<ArrayBuffer>): ArrayBuffer {
  if (frames.length === 0) {
    return new ArrayBuffer(0);
  }
  let total = 0;
  for (const f of frames) {
    const len = f.byteLength;
    if (len > 65535) {
      throw new Error(`Opus 子帧过大（>${65535} 字节），无法写入 u16 长度`);
    }
    total += 2 + len;
  }
  const out = new ArrayBuffer(total);
  const u8 = new Uint8Array(out);
  let o = 0;
  for (const f of frames) {
    const n = f.byteLength;
    u8[o] = n & 0xff;
    u8[o + 1] = (n >> 8) & 0xff;
    o += 2;
    u8.set(new Uint8Array(f), o);
    o += n;
  }
  return out;
}
